import React from "react";
import "../../App.css";
import "./ActionsBar.css";
import {
  CalculateActionButton,
  PrintResultsActionButton,
  SaveResultsActionButton,
} from "../ActionButton/ActionButton";
import Wrapper from "../Wrapper/Wrapper";
import ActionButtons from "../ActionButtons/ActionButtons";

function ActionsBar({ hasResults, onCalculate, onSave, serverMessages }) {
  const handlePrintButtonClicked = () => {
    window.print();
  };

  return (
    <div className={"action-bar"}>
      <Wrapper className={"wrapper"}>
        <span>Fyll i gula celler</span>

        <ActionButtons>
          {serverMessages
            ? serverMessages.length > 0 && (
                <div>
                  {Array.isArray(serverMessages)
                    ? serverMessages.map((e, i) => (
                        <span key={"error" + i}>{e}</span>
                      ))
                    : serverMessages}
                </div>
              )
            : null}

          <CalculateActionButton onClick={onCalculate} />

          <SaveResultsActionButton disabled={!hasResults} onClick={onSave} />

          <PrintResultsActionButton
            disabled={!hasResults}
            onClick={handlePrintButtonClicked}
          />
        </ActionButtons>
      </Wrapper>
    </div>
  );
}

export default ActionsBar;
